import React, { Component } from "react";

class ServiceAndRefundPolicy extends Component {
  render() {
    return (
      <div className="flex-center-center" style={{ height: "500px" }}>
        <h3>Askademia Tutoring Terms and Service and Refund Policy</h3>
      </div>
    );
  }
}

export default ServiceAndRefundPolicy;
